import { render, staticRenderFns } from "./StatsWidgetChart.vue?vue&type=template&id=208bca1f"
import script from "./StatsWidgetChart.vue?vue&type=script&lang=js"
export * from "./StatsWidgetChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports